import React, { useState } from 'react'
import { Outlet, NavLink, Link, useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import './Layout.css'

export default function Layout() {
  const { user, participant, redemptionParticipant, activePool, setActivePool, signOut } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const [menuOpen, setMenuOpen] = useState(false)

  const hasRedemption = !!(redemptionParticipant && !redemptionParticipant.is_eliminated)

  async function handleSignOut() {
    setMenuOpen(false)
    try {
      await signOut()
    } catch {
      // ignore — clear local state regardless
    }
    navigate('/login')
  }

  function closeMenu() { setMenuOpen(false) }

  function togglePool() {
    const next = activePool === 'main' ? 'redemption' : 'main'
    setActivePool(next)
    if (location.pathname === '/picks' || location.pathname === '/redemption/picks') {
      navigate(next === 'redemption' ? '/redemption/picks' : '/picks')
    }
    setMenuOpen(false)
  }

  // REDEMPTION HIDDEN — always route to main picks
  const picksPath = '/picks'

  return (
    <div className="app-shell">{/* redemption-mode class hidden */}
      <header className="app-header">
        <div className="header-inner">
          <Link to="/dashboard" className="header-brand">
            <img src="/logo.png" alt="March Madness Survivor Pool" className="brand-logo" />
          </Link>

          {/* Desktop nav */}
          <nav className="header-nav desktop-nav">
            <NavLink to="/dashboard" className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'}>Headquarters</NavLink>
            <NavLink to={picksPath} className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'}>My Picks</NavLink>
            <NavLink to="/standings" className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'}>Standings</NavLink>
            <NavLink to="/recaps" className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'}>Recaps</NavLink>
            <NavLink to="/rules" className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'}>Rules</NavLink>
            {participant?.is_admin && (
              <NavLink to="/admin" className={({isActive}) => isActive ? 'nav-link admin-link active' : 'nav-link admin-link'}>Admin</NavLink>
            )}
          </nav>

          {false && hasRedemption && ( /* REDEMPTION HIDDEN */
            <button
              className={`pool-toggle desktop-only${activePool === 'redemption' ? ' redemption-active' : ''}`}
              onClick={togglePool}
              title={activePool === 'main' ? 'Switch to Redemption Island' : 'Switch to Main Pool'}
            >
              {activePool === 'redemption' ? '🏝️ Redemption' : '🏀 Main Pool'}
            </button>
          )}

          {user
            ? <button className="signout-btn desktop-only" onClick={handleSignOut}>Sign out</button>
            : <button className="signout-btn desktop-only" onClick={() => navigate('/login')}>Log in</button>
          }

          {/* Hamburger button — mobile only */}
          <button
            className={`hamburger${menuOpen ? ' open' : ''}`}
            onClick={() => setMenuOpen(o => !o)}
            aria-label="Toggle menu"
          >
            <span /><span /><span />
          </button>
        </div>

        {/* Mobile menu */}
        {menuOpen && (
          <nav className="mobile-nav">
            <NavLink to="/dashboard" className={({isActive}) => isActive ? 'mobile-nav-link active' : 'mobile-nav-link'} onClick={closeMenu}>Headquarters</NavLink>
            <NavLink to={picksPath} className={({isActive}) => isActive ? 'mobile-nav-link active' : 'mobile-nav-link'} onClick={closeMenu}>My Picks</NavLink>
            <NavLink to="/standings" className={({isActive}) => isActive ? 'mobile-nav-link active' : 'mobile-nav-link'} onClick={closeMenu}>Standings</NavLink>
            <NavLink to="/recaps" className={({isActive}) => isActive ? 'mobile-nav-link active' : 'mobile-nav-link'} onClick={closeMenu}>Recaps</NavLink>
            <NavLink to="/rules" className={({isActive}) => isActive ? 'mobile-nav-link active' : 'mobile-nav-link'} onClick={closeMenu}>Rules</NavLink>
            {participant?.is_admin && (
              <NavLink to="/admin" className={({isActive}) => isActive ? 'mobile-nav-link admin-link active' : 'mobile-nav-link admin-link'} onClick={closeMenu}>Admin</NavLink>
            )}
            {false && hasRedemption && ( /* REDEMPTION HIDDEN */
              <button
                className={`mobile-pool-toggle${activePool === 'redemption' ? ' redemption-active' : ''}`}
                onClick={togglePool}
              >
                {activePool === 'redemption' ? '🏝️ Redemption Island' : '🏀 Main Pool'}
              </button>
            )}
            {user
              ? <button className="mobile-signout-btn" onClick={handleSignOut}>Sign out</button>
              : <button className="mobile-signout-btn" onClick={() => { navigate('/login'); closeMenu() }}>Log in</button>
            }
          </nav>
        )}
      </header>
      <main className="app-main">
        <Outlet />
      </main>
    </div>
  )
}
